/**
 * Cloud Function HTTP endpoints (us-central1, endemico-2025).
 * After deploy, verify URLs in Firebase console if a function fails to reach.
 */
const PROJECT_ID = 'endemico-2025';
const REGION = 'us-central1';

const cloudFunctionsNet = (name) =>
  `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/${name}`;

const cloudRun = (name) =>
  `https://${name.toLowerCase()}-yepdp67tpq-uc.a.run.app`;

export const CAMO_FUNCTION_URLS = {
  generateA: cloudRun('generateCamoDesignA'),
  generateB: cloudRun('generateCamoDesignB'),
  edit: cloudRun('editCamoDesign'),
  playground: cloudRun('generateCamoDesignPlayground'),
  consult: cloudRun('consultCamo'),
  processDesignRefinement: cloudFunctionsNet('processDesignRefinement'),
  processPlaygroundRefinement: cloudFunctionsNet('processPlaygroundRefinement'),
  bootstrapCamoPrompts: cloudFunctionsNet('bootstrapCamoPrompts'),
};

/**
 * Fire-and-forget refinement request — never blocks UI on failure.
 */
export async function triggerDesignRefinement({ designId, userId, idToken }) {
  try {
    await fetch(CAMO_FUNCTION_URLS.processDesignRefinement, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ designId, userId }),
    });
  } catch (error) {
    console.warn('Prompt refinement request failed (non-blocking):', error);
  }
}

export async function triggerPlaygroundRefinement({ testId, userId, idToken }) {
  try {
    await fetch(CAMO_FUNCTION_URLS.processPlaygroundRefinement, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ testId, userId }),
    });
  } catch (error) {
    console.warn('Playground refinement request failed (non-blocking):', error);
  }
}
